import { render, staticRenderFns } from "./ImgText.vue?vue&type=template&id=86db17a0"
import script from "./ImgText.vue?vue&type=script&lang=js"
export * from "./ImgText.vue?vue&type=script&lang=js"
import style0 from "./ImgText.vue?vue&type=style&index=0&id=86db17a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports